import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './Section';
import './Certifications.css';

export function Certifications({ items }) {
  return (
    <Section id="certifications" title="Certifications">
      <div className="certifications-list">
        {items.map((cert, index) => (
          <motion.div
            key={cert.id}
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true, margin: '-100px' }}
            className="certification-item"
          >
            <div className="certification-check">✓</div>
            <h4 className="certification-name">{cert.name}</h4>
            <p className="certification-year">{cert.year}</p>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
